module.exports = __webpack_public_path__ + "static/dryer-cd563189d006b9763ffac6e43f23dc09.jpg";